import { IItem } from '../search-dropdown/common/interface';
import { IDates } from '../calendar/calendar';
import { IFacets, IState } from './interface';

type Actions =
    | { type: 'SELECT_ITEM'; selected: 'region' | 'brand' | 'ship'; selectedItem: IItem | null }
    | { type: 'SELECT_DATES'; selectedDates: IDates }
    | { type: 'RESET_FILTERS'; defaultState: IState }
    | { type: 'SELECT_WITH_FLIGHTS'; selected: boolean | null | undefined }
    | { type: 'RECEIVE_DATA'; data: IFacets };

export function reducer(state: IState, action: Actions): IState {
    switch (action.type) {
        case 'SELECT_ITEM':
            const { selected, selectedItem } = action;
            return {
                ...state,

                ...(selected === 'region'
                    ? { selectedRegion: selectedItem }
                    : selected === 'ship'
                    ? { selectedShip: selectedItem }
                    : { selectedBrand: selectedItem }),
                isLoading: true,
            };

        case 'SELECT_DATES':
            return {
                ...state,
                startDate: action.selectedDates.startDate || null,
                endDate: action.selectedDates.endDate || null,
                isLoading: true,
            };

        case 'RESET_FILTERS':
            return {
                ...action.defaultState,

                isLoading: true,
            };

        case 'SELECT_WITH_FLIGHTS':
            return {
                ...state,
                withFlights: action.selected,
                isLoading: true,
            };

        case 'RECEIVE_DATA':
            if (!action.data.totalCount) {
                const { selectedBrand, selectedRegion, selectedShip } = state;
                return {
                    ...state,

                    ...action.data,

                    ...(selectedBrand && {
                        brandItems: { top: [], all: [{ ...selectedBrand, count: 0 }] },
                    }),
                    ...(selectedRegion && {
                        regionItems: { top: [], all: [{ ...selectedRegion, count: 0 }] },
                    }),
                    ...(selectedShip && {
                        shipItems: { top: [], all: [{ ...selectedShip, count: 0 }] },
                    }),
                    selectedBrand: selectedBrand ? { ...selectedBrand, count: 0 } : null,
                    selectedRegion: selectedRegion ? { ...selectedRegion, count: 0 } : null,
                    selectedShip: selectedShip ? { ...selectedShip, count: 0 } : null,
                    isLoading: false,
                };
            } else {
                const { brandItems, regionItems, shipItems, totalCount, withFlights } = action.data;
                const { selectedBrand, selectedRegion, selectedShip } = state;

                const newSelectedBrand =
                    brandItems.all.find(({ key }) => selectedBrand?.key === key) || null;
                const newSelectedRegion =
                    regionItems.all.find(({ key }) => selectedRegion?.key === key) || null;

                const newSelectedShip =
                    shipItems.all.find(({ key }) => selectedShip?.key === key) || null;

                const isSelectedBrandAbsentFromResult = !newSelectedBrand && selectedBrand;
                const isSelectedRegionAbsentFromResult = !newSelectedRegion && selectedRegion;
                const isSelectedShipAbsentFromResult = !newSelectedShip && selectedShip;

                const allBrands = isSelectedBrandAbsentFromResult
                    ? [...brandItems.all, { ...(selectedBrand as IItem), count: 0 }]
                    : brandItems.all;

                const allRegions = isSelectedRegionAbsentFromResult
                    ? [...regionItems.all, { ...(selectedRegion as IItem), count: 0 }]
                    : regionItems.all;

                const allShips = isSelectedShipAbsentFromResult
                    ? [...shipItems.all, { ...(selectedShip as IItem), count: 0 }]
                    : shipItems.all;

                return {
                    ...state,

                    totalCount,
                    withFlights,
                    regionItems: { ...regionItems, all: allRegions },
                    brandItems: { ...brandItems, all: allBrands },
                    shipItems: { ...shipItems, all: allShips },
                    selectedBrand: isSelectedBrandAbsentFromResult
                        ? { ...(selectedBrand as IItem), count: 0 }
                        : newSelectedBrand,
                    selectedRegion: isSelectedRegionAbsentFromResult
                        ? { ...(selectedRegion as IItem), count: 0 }
                        : newSelectedRegion,
                    selectedShip: isSelectedShipAbsentFromResult
                        ? { ...(selectedShip as IItem), count: 0 }
                        : newSelectedShip,
                    isLoading: false,
                };
            }
        default:
            const _exhaustiveCheck: never = action;
            return _exhaustiveCheck;
    }
}
